
import axios from "../lib/axios";

export const deleteImage = async (path) => {
    return await (
        await axios.post(`https://us-central1-techreusetoolkit.cloudfunctions.net/mysql/deleteStorageFile`, {
            filePath: path
        })
    ).data;
}